import type { Entity } from 'src/lib/collection';
import { parseJson } from 'src/lib/common';

interface Bookmark extends Entity {
  type: BookmarkType;
  name: string;
  link: string;
  metadata: string;
}

export const BOOKMARK_TYPE = {
  projectType: 'project_type',
} as const;
export type BookmarkType = (typeof BOOKMARK_TYPE)[keyof typeof BOOKMARK_TYPE];

const PROJECT_TYPE_NAME_DELIMITER = ',';
export const formatProjectTypeBookmarkName = (projectType: string, generationTool?: string) => {
  if (generationTool) {
    return `${projectType}${PROJECT_TYPE_NAME_DELIMITER}${generationTool}`;
  }
  return `${projectType}`;
};

export const prepareBookmark = (bookmark: Bookmark) => ({
  ...bookmark,
  metadata: parseJson(bookmark.metadata),
});
